import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PaneComponent } from '@rocksoft/cdk';
import { isOsVersionAtLeast } from '@rocksoft/shared';
import { OSSupportedPipe } from '../../../../pipes/os-supported.pipe';
import { AppleDevice } from '../../../../viewmodels/apple/apple-device.model';
import { DisableLostModeComponent } from '../disable-lost-mode/disable-lost-mode.component';
import { EnableLostModeComponent } from '../enable-lost-mode/enable-lost-mode.component';
import { PlayLostModeSoundComponent } from '../play-lost-mode-sound/play-lost-mode-sound.component';

@Component({
  selector: 'ml-mdm-apple-lost-mode',
  templateUrl: './apple-lost-mode.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PaneComponent,
    EnableLostModeComponent,
    DisableLostModeComponent,
    PlayLostModeSoundComponent,
    FaIconComponent,
    OSSupportedPipe,
  ],
})
export class AppleLostModeComponent {
  public readonly apple = input.required<AppleDevice>();

  readonly isLostModeEnabled = computed(() => this.apple().isMDMLostModeEnabled ?? false);
  readonly isSupervised = computed(() => this.apple()?.isSupervised ?? false);
  readonly hasSupportedOS = computed(() => isOsVersionAtLeast(this.apple().osVersion, '9.3.0'));

  get isSupported() {
    return this.isSupervised() && this.hasSupportedOS();
  }
}
